import { RootState } from '@/app/store.ts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MeansOfPaymentsState {
  dialogAddPaymentMethodOpen: boolean;
  displayMode: 'cards' | 'grid';
}

const initialState: MeansOfPaymentsState = {
  dialogAddPaymentMethodOpen: false,
  displayMode: 'grid',
};

export const meansOfPaymentsSlice = createSlice({
  name: 'meansOfPayments',
  initialState,
  reducers: {
    /**
     * Open or close the dialog to add a payment method
     *
     * @param state  State of the means of payments
     * @param action Action to perform
     */
    setDialogAddPaymentMethodOpen: (state, action: PayloadAction<boolean>) => {
      state.dialogAddPaymentMethodOpen = action.payload;
    },

    /**
     * Set the display mode
     *
     * @param state  State of the means of payments
     * @param action Action to perform
     */
    setDisplayMode: (state, action: PayloadAction<'cards' | 'grid'>) => {
      state.displayMode = action.payload;
    },
  },
});

export const { setDialogAddPaymentMethodOpen, setDisplayMode } =
  meansOfPaymentsSlice.actions;

/**
 * Get the means of payments state
 *
 * @param state The root state
 *
 * @returns     The means of payments state
 */
export const getMeansOfPaymentsState = (state: RootState) =>
  state.meansOfPayments;
